import axiosInstance from '@fs/zion-axios'
import getProductHeader from '../common/getProductHeader'

/** Feature segment for the source-centric person page. */
export const SOURCE_CENTRIC_PERSON_PAGE = 'tree:scperson'

/**
 * Feature segment for writes made while an in-context record hint is being processed on that page.
 * Derived from SOURCE_CENTRIC_PERSON_PAGE so the two cannot drift apart.
 */
export const SOURCE_CENTRIC_RECORD_HINT = `${SOURCE_CENTRIC_PERSON_PAGE}:hint:rec`

let isActive = false

export function setSourceCentricDetailsActive(active: boolean): void {
  isActive = active
}

axiosInstance.interceptors.request.use((config) => {
  if (!isActive) return config

  // Don't attach Product to cross-origin requests — it isn't in their CORS Access-Control-Allow-Headers.
  // Same guard as @fs/zion-axios's built-in productHeaderInterceptor (see FRONTIER-4488).
  const url = config.url ?? ''
  const isCrossOrigin =
    url.startsWith('http') && typeof window !== 'undefined' && !url.startsWith(window.location.origin)
  if (isCrossOrigin) return config

  // `false` means an already-set Product header wins, so a caller that attributes its own request —
  // @fs/zion-linker's info sheet marks its writes as hint-initiated — is not overwritten here.
  // Using set() rather than assigning config.headers.product also keeps the key normalized, so the
  // caller's `Product` and this one cannot both end up on the request.
  config.headers.set('Product', getProductHeader({ featureOverride: SOURCE_CENTRIC_PERSON_PAGE }), false)

  return config
})
